<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-card>
            <v-card-title class="px-6">Edit Business Profile</v-card-title>
            <v-card-text>
              <v-layout justify-start align-start>
                <v-flex shrink>
                  <div class="px-4 py-3">
                    <v-img :src="logo" width="90"></v-img>
                  </div>
                </v-flex>
              </v-layout>

              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1"> Business Name</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Slogon</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="slogon"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Address</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Telephone</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  type="number"
                  v-model="phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">email (optional)</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="email"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1"> Country</span>
                <v-select
                  :items="country_list"
                  v-model="country"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Currency</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="currency"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">State / Region</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="region"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Website</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="website"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Upload Businesss Profile </span>
                <v-file-input
                  outlined
                  prepend-icon=""
                  dense
                  v-model="logo"
                  id="file"
                  color="primary"
                  @change="Preview_image"
                  prepend-inner-icon="mdi-camera"
                  accept="image/png, image/jpeg, image/bmp"
                ></v-file-input>
                <v-img :src="url" width="200" />
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-card-actions>
                  <v-snackbar v-model="alert" color="success">
                    Business updated successfully
                  </v-snackbar>

                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="loading" @click="create()"
                    >Save Changes</v-btn
                  >
                </v-card-actions>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "Home",

  components: {},
  data: () => ({
    url: null,
    name: "",
    email: "",
    slogon: "",
    address: "",
    phone: "",
    overlay: false,
    country: "",
    currency: "",
    region: "",
    website: "",
    logo: "",
    loading: false,
    alert: false,
    country_list: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antigua &amp; Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia &amp; Herzegovina",
      "Botswana",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Cape Verde",
      "Cayman Islands",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Cote D Ivoire",
      "Croatia",
      "Cruise Ship",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "French West Indies",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyz Republic",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Namibia",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Pierre &amp; Miquelon",
      "Samoa",
      "San Marino",
      "Satellite",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "St Kitts &amp; Nevis",
      "St Lucia",
      "St Vincent",
      "St. Lucia",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor L'Este",
      "Togo",
      "Tonga",
      "Trinidad &amp; Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks &amp; Caicos",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "Uruguay",
      "Uzbekistan",
      "Venezuela",
      "Vietnam",
      "Virgin Islands (US)",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ],
    id: "",
  }),

  methods: {
    Preview_image() {
      this.url = URL.createObjectURL(this.logo);
    },

    getProfile() {
      this.overlay = true;
      fetch("https://receipt.drecsoft.com/api/v1/business/profile", {
        headers: {
          Authorization: `Bearer ${this.currentUser}`,
        },
        method: "POST",
      })
        .then((res) => res.json())
        .then((res) => {
          this.overlay = false;
          let docs = res.data.business;

          this.name = docs.business_name;
          this.slogon = docs.motto;
          this.address = docs.address;
          this.phone = docs.telephone;
          this.region = docs.region;
          this.country = docs.country;
          this.email = docs.email;
          this.currency = docs.currency;
          this.website = docs.website;
          this.logo = docs.logo;
          this.id = docs.id;

          console.log(res.data.business);
        })
        .catch((err) => console.log(err));
    },
    create() {
      this.loading = true;

      const formdata = new FormData();

      formdata.append("business_name", this.name);
      formdata.append("motto", this.slogon);
      formdata.append("address", this.address);
      formdata.append("country", this.country);
      formdata.append("currency", this.currency);
      formdata.append("region", this.region);
      formdata.append("telephone", this.phone);
      formdata.append("website", this.website);
      formdata.append("email", this.email);
      formdata.append("logo", this.logo);
      formdata.append("business_id", this.id);

      console.log(formdata);

      axios
        .post(
          "https://receipt.drecsoft.com/api/v1/business/update-profile",
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.currentUser}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.alert = true;
          this.loading = false;
          (this.name = ""), (this.email = "");
          this.region = "";
          this.logo = "";
          this.slogon = "";
          this.address = "";
          this.country = "";
          this.currency = "";
          this.email = "";
          this.website = "";
          setTimeout(() => {
            this.$router.go();
          }, 2000);
        })
        .catch((err) => {
          (this.loading = false), console.log(err);
        });
    },
  },

  mounted() {
    this.getProfile();
  },
  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },
};
</script>

<style  scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>
